<template>
  <v-row>
    <v-col class="d-flex">
      <v-spacer></v-spacer>
      <v-btn class="mb-2 mr-2" color="primary" v-on:click="this.onClick">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    props: {
      onClick: Function
    }
  }
</script>
